<template>
  <div>
    <v-snackbar
      :color="passwebHintType"
      width="100%"
      v-model="showAlert"
      top
      timeout="-1"
      absolute
    >
      {{ passwebHint }}
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="showAlert = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-row align="center" class="pt-3">
      <v-col cols="12" md="6">
        <v-text-field
          label="Identifiant de passweb"
          v-model.number="parentClientPortalForm.passmanId"
          :rules="rules.passmanIdRules"
          @keydown="() => clearTypingTimer(typingTimerIdPassmanId)"
          @keyup="triggerTypingTimerPassmanId"
          :loading="passmanIdLoading"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <span>{{ clientName }}</span>
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="Référence client"
          v-model="parentClientPortalForm.reference"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="Nom ou description"
          v-model="parentClientPortalForm.description"
          :rules="rules.descriptionRules"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-select
          v-model="partnerId"
          label="Partenaire"
          :items="partners"
          item-value="id"
          item-text="name"
          :rules="rules.partnerRules"
          :loading="loadingPartenaires"
          dense
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-autocomplete
          v-model="parentClientPortalForm.group"
          :items="groups.data"
          :search-input.sync="search"
          no-filter
          item-text="description"
          color="blue-grey lighten-2"
          label="Groupe"
          item-value="id"
          hide-selected
          no-data-text="Pas de groupe correspondant à la recherche"
          :loading="loadingGroupes"
          dense
          persistent-hint
          hint="Vous pouvez sélectionner uniquement des GROUPES V5"
        >
          <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
              <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-content>
                <v-list-item-title>{{
                  data.item.description
                }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12">
        <v-select
          v-model="parentClientPortalForm.portalProfile"
          return-object
          label="Template prédéfini"
          :items="portalProfiles"
          item-value="id"
          item-text="name"
          dense
          :loading="loadingGroupes"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { useGroup } from "@/composables/group";
import { ref, toRefs, watch, computed, onMounted } from "@vue/composition-api";
import { usePortalProfile } from "@/composables/portal-profile";
import { useTestPassweb } from "@/composables/test-passweb";
import { usePartner } from "@/composables/partner";

export default {
  props: {
    clientPortalForm: Object,
    formRef: null,
    rules: Object,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { data: groupData, listGroups } = useGroup();
    const { partnerData, listPartners } = usePartner();
    const { portalProfiles, listPortalProfileV5 } = usePortalProfile();
    const { passwebData, testPassweb } = useTestPassweb();

    /* Cycle de vie */
    onMounted(async () => {
      parentClientPortalForm.value.isActive = true;
      loadingPartenaires.value = true;
      await listPartners();
      partnerId.value = partnerData.partners[0].id;
      loadingPartenaires.value = false;
    });

    /* Computed */
    const parentClientPortalForm = computed({
      get: () => props.clientPortalForm,
      set: (value) => {
        emit("update:clientPortalForm", value);
      },
    });

    /* Variables */
    const search = ref(null);
    const passwebHint = ref(null);
    const passwebHintType = ref("success");
    let typingTimerIdPassmanId = 0;
    const debounceInterval = 500;
    const passmanIdLoading = ref(false);
    const clientName = ref("");
    const showAlert = ref(false);
    const loadingPartenaires = ref(false);
    const loadingGroupes = ref(false);
    const partnerId = ref(-1);
    const clientReference = ref("");

    /* Méthodes */
    const triggerTypingTimerPassmanId = function () {
      clearTimeout(typingTimerIdPassmanId);
      typingTimerIdPassmanId = setTimeout(function () {
        testPasswebValidity();
      }, debounceInterval);
    };
    const clearTypingTimer = function (timerId) {
      clearTimeout(timerId);
    };
    const capitalize = function (str) {
      return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
    };
    const testPasswebValidity = async () => {
      if (
        parentClientPortalForm.value.passmanId != null &&
        parentClientPortalForm.value.passmanId != undefined &&
        parentClientPortalForm.value.passmanId != ""
      ) {
        passmanIdLoading.value = true;
        await testPassweb(parentClientPortalForm.value.passmanId);
        passmanIdLoading.value = false;
        console.log(passwebData.value);
        showAlert.value = true;
        if (passwebData.value.count > 0) {
          passwebHint.value =
            "Another client already have this passmanID (passweb)";
          passwebHintType.value = "warning";
          clientName.value = passwebData.value[0].NomClient.split(" ")
            .map(capitalize)
            .join(" ");
          clientReference.value = passwebData.value[0].IDExternal;
        } else if (
          passwebData.value[0] != undefined &&
          passwebData.value[0].IDPassman != undefined
        ) {
          passwebHint.value =
            "The passweb identifier match with an existing one.";
          passwebHintType.value = "success";
          clientName.value = passwebData.value[0].NomClient.split(" ")
            .map(capitalize)
            .join(" ");
          clientReference.value = passwebData.value[0].IDExternal;
        } else {
          passwebHint.value =
            "The passweb identifier does't match with an existing one! You need to provide a correct one";
          passwebHintType.value = "error";
        }
        parentClientPortalForm.value.description = "";
        parentClientPortalForm.value.description = `${clientName.value}${
          parentClientPortalForm.value.description ?? ""
        }`;
        parentClientPortalForm.value.reference = clientReference.value;
      }
    };

    /* Actions */
    delete groupData.rules; // remove warning,not a proper way

    /* Watchers */
    watch(
      () => search.value,
      function (newValue, oldValue) {
        if (newValue != oldValue && newValue != null) {
          listGroups(newValue);
        }
      }
    );

    watch(
      () => partnerId.value,
      async (newValue) => {
        parentClientPortalForm.value.partner = newValue;
        loadingGroupes.value = true;
        await listPortalProfileV5(newValue);
        loadingGroupes.value = false;
        parentClientPortalForm.value.portalProfile = portalProfiles.value[0];
      },
      { deep: true }
    );

    parentClientPortalForm.value.isActive = true;

    return {
      parentClientPortalForm,
      search,
      ...toRefs(groupData),
      ...toRefs(partnerData),
      portalProfiles,
      passwebHint,
      passwebHintType,
      triggerTypingTimerPassmanId,
      clearTypingTimer,
      passmanIdLoading,
      clientName,
      typingTimerIdPassmanId,
      showAlert,
      loadingPartenaires,
      loadingGroupes,
      partnerId,
    };
  },
};
</script>
